export default __webpack_public_path__ + "static/media/bubble_2.c3be6ea4.svg";